/** PostHog feature flag keys. Every flag the app reads must be declared here. */
export const FEATURE_FLAGS = {
  // App-wide
  APP_VERSION_VALID: 'app_version_valid',

  // Onboarding
  HIDE_ONBOARDING_FORM: 'hide_onboarding_form',
  HIDE_PRIMARY_VET_ONBOARDING: 'hide_primary_vet_onboarding',

  // Web app features
  WEB_APP_DASHBOARD: 'web_app_dashboard',
  WEB_APP_PET: 'web_app_pet',
  WEB_APP_RENTERS: 'web_app_renters',
  WEB_APP_CLAIMS: 'web_app_claims',
  WEB_APP_PERKS: 'web_app_perks',
  WEB_APP_GOALS: 'web_app_goals',
  WEB_APP_DOCUMENTS: 'web_app_documents',
  WEB_APP_PAYMENT: 'web_app_payment',
  WEB_APP_CONTACT: 'web_app_contact',
  WEB_APP_BILLING: 'web_app_billing',
  WEB_APP_REFER: 'web_app_refer',
  WEB_APP_MARKETING: 'web_app_marketing',
  WEB_APP_CROSS_SELL_RENTERS: 'web_app_cross_sell_renters',
  WEB_APP_CROSS_SELL_PET: 'web_app_cross_sell_pet',
  WEB_APP_PROFILE: 'web_app_profile',
} as const

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS]
